import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import uniqBy from 'lodash/uniqBy';
import isEmail from 'validator/es/lib/isEmail';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

function SelectUser(props) {
  const { orgId, userId, setUser } = props;

  const allMemberships = useSelector((state) => state.memberships.data);
  const [availableUsers, setAvailableUsers] = useState([]);

  useEffect(() => {
    if (orgId) {
      const orgMemberships = filter(allMemberships, { org_id: orgId });
      const orgUserIds = orgMemberships.map((membership) => membership.user_id);

      let usersNotInCurrentOrg = filter(allMemberships, (membership) => {
        return membership.org_id !== orgId;
      });
      usersNotInCurrentOrg = filter(usersNotInCurrentOrg, (membership) => {
        return !orgUserIds.includes(membership.user_id);
      });
      usersNotInCurrentOrg = uniqBy(usersNotInCurrentOrg, 'user_id');

      setAvailableUsers(
        usersNotInCurrentOrg.map((membership) => {
          return {
            user_id: membership.user_id,
            name: membership.name,
            email: membership.email,
            type_: 'user',
          };
        })
      );
    } else {
      setAvailableUsers([]);
    }
  }, [allMemberships, orgId]);

  const handleChange = (event, value, reason) => {
    if (typeof value === 'string' && value.startsWith('New User: ')) {
      const email = value.replace('New User: ', '');
      setUser({ email });
    } else if (value?.type_ === 'user') {
      setUser(value);
    }
  };

  return (
    <Autocomplete
      fullWidth
      data-lpignore='true'
      autoComplete
      autoHighlight
      autoSelect
      freeSolo
      onChange={handleChange}
      options={availableUsers}
      getOptionLabel={(option) => {
        const label = (() => {
          if (option?.name && option?.email) {
            return `${option.name} (${option.email})`;
          } else if (typeof option === 'string') {
            return option;
          }
          return '';
        })();

        return label;
      }}
      filterOptions={(options, params) => {
        const filtered = createFilterOptions()(options, params);

        const { inputValue } = params;
        // Suggest the creation of a new value
        const isExisting = options.some(
          (option) => inputValue === option.email
        );
        if (inputValue !== '' && !isExisting && isEmail(inputValue)) {
          filtered.push(`New User: ${inputValue}`);
        }
        return filtered;
      }}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            fullWidth
            disabled={!orgId}
            label='User'
            variant='standard'
            value={userId}
          />
        );
      }}
      slotProps={{
        listbox: { sx: { p: 0 } },
      }}
    />
  );
}

SelectUser.propTypes = {
  orgId: PropTypes.string,
  userId: PropTypes.string.isRequired,
  setUser: PropTypes.func.isRequired,
};

export default SelectUser;
